import { Translatable } from "@icc/shared/helpers";

export class PlasterStrip {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Kod do wydruków */
    printCode: string;
    /** Zdjęcie */
    img: string;
    /** Typ elementu skrzynki żaluzji */
    blindBoxComponentTypeId: number;
    /** Listwa tynkowa zewnętrzna */
    outerPlasterStrip: boolean;
    /** Listwa tynkowa wewnętrzna */
    innerPlasterStrip: boolean;
    /** Masa stała [kg] */
    weightConst?: number;
    /** Masa za metr bieżący [kg] */
    weight?: number;
    /** Głębokość [mm] */
    depth?: number;
    /** Wysokość [mm] */
    height?: number;
    /** Maksymalna długość [mm] */
    maxLength?: number;
    /** Zestaw grup kolorów */
    colorGroupSetId?: number | null;
    /** Pasujące profile skrzynek */
    profilesIds?: number[];
}